import type { ReactElement } from "react";
import { ActionPill } from "./ActionPill";

export type QuickActionItem = {
  icon: ReactElement;
  color?: string;
  label: string;
  description?: string;
  actionText?: string;
  customClass?: string;
  onClick?: () => void;
};

// Backward-compatibility type alias
export type GlassIconsItem = QuickActionItem;

type QuickActionGridProps = {
  items: QuickActionItem[];
  className?: string;
};

export function QuickActionGrid({ items, className = "" }: QuickActionGridProps) {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3.5 ${className}`.trim()}>
      {items.map((item, index) => (
        <button
          key={`${item.label}-${index}`}
          type="button"
          onClick={item.onClick}
          className={`group flex min-h-40 flex-col justify-between rounded-card border border-border bg-card p-4 text-left shadow-soft transition-[transform,border-color] duration-200 hover:-translate-y-0.5 hover:border-primary/50 focus-visible:ring-2 ring-ring motion-reduce:transition-none motion-reduce:hover:transform-none sm:p-5 ${item.customClass ?? ""}`.trim()}
          aria-label={item.label}
        >
          <div>
            <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-accent-soft text-primary transition-colors group-hover:bg-primary group-hover:text-on-accent" aria-hidden="true">
              {item.icon}
            </span>
            <h4 className="font-display text-base font-bold tracking-tight text-foreground">{item.label}</h4>
            {item.description && <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-muted-foreground">{item.description}</p>}
          </div>
          <div className="mt-4">
            <ActionPill>{item.actionText || "Open"}</ActionPill>
          </div>
        </button>
      ))}
    </div>
  );
}

// Backward-compatibility export
export const GlassIcons = QuickActionGrid;
